<template lang="html">
  <!-- Header -->
  <header>
    <nav class="navbar header-nav header-nav-dark header-nav-style-1 navbar-expand-lg">
      <div class="container container-large">
        <!-- Brand -->
        <router-link class="navbar-brand" to="/">
          <!-- <img class="light-logo" src="static/img/logo-light.svg" title="" alt="">
          <img class="dark-logo" src="static/img/logo.svg" title="" alt=""> -->
          <h1 class="navbar-logo">Codoc</h1>
        </router-link>
        <!-- / -->

        <!-- Mobile Toggle -->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
            <span></span>
            <span></span>
            <span></span>
        </button>
        <!-- / -->

        <!-- Top Menu -->
        <div class="collapse navbar-collapse justify-content-end" id="navbar">
          <ul class="navbar-nav ml-auto align-items-center" >
            <li class="m-dropdown m-dropdown-multilevel" v-if="false">
              <a class="nav-link" href="#home">Home</a>
              <i class="fa fa-angle-down m-dropdown-toggle"></i>
              <ul class="m-dropdown-menu">
                  <li><a href="index.html">Home Option 1</a></li>
                  <li><a href="index-01.html">Home Option 2</a></li>
                  <li><a href="index-02.html">Home Option 3</a></li>
              </ul>
            </li>
            <li v-if="false"><a class="nav-link" href="#about">About Us</a></li>
            <li v-if="false"><a class="nav-link" href="#feature">Features</a></li>
            <li v-if="false"><a class="nav-link" href="#price">Price</a></li>
            <li v-if="false"><a class="nav-link" href="#blog">Blog</a></li>
            <li v-if="false"><a class="nav-link" href="#contatus">Contact</a></li>
            <li v-if="false" class="m-dropdown m-dropdown-multilevel">
              <a class="nav-link" href="#">Pages</a>
              <i class="fa fa-angle-down m-dropdown-toggle"></i>
              <ul class="m-dropdown-menu">
                  <li><a href="about-us.html">About Us</a></li>
                  <li><a href="services.html">Services</a></li>
                  <li><a href="features.html">Features</a></li>
                  <li><a href="team.html">Team</a></li>
                  <li><a href="contact-us.html">Contact Us</a></li>
                  <li><a href="blog.html">Blog Listing</a></li>
                  <li><a href="blog-details.html">Blog Details</a></li>
              </ul>
            </li>
            <li><router-link class="nav-link-btn btn btn-theme m-15px-l md-m-0px-l" :to="'/signin'">Sign In</router-link></li>
          </ul>
        </div>
        <!-- / -->

      </div><!-- Container -->
    </nav> <!-- Navbar -->
  </header>
  <!-- Header End -->
</template>

<script>
// import { mapState, mapGetters, mapActions } from 'vuex'
import firebase from 'firebase'
export default {
  data(){
    return {
      //loginOnly: false
    }
  },
  mounted: function () {
  },
  methods : {
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';
@import '~styles/basetheme';
@import '~styles/basecolors';

.navbar-logo {
  font-size: 1.9rem;
  font-weight: 600;
  color: #323232;
  font-family: 'Lora';
  font-weight: 700;
}
// The fixed header has a white background, so we'll need to change it.
.fixed-header {
  .navbar-logo {
    color: #000;
  }
}

@media (max-width: 991px) {
  .navbar-logo {
    color: #000;
  }
}
</style>
